import { render, staticRenderFns } from "./SidebarFieldEdit.vue?vue&type=template&id=45f4b2dc"
import script from "./SidebarFieldEdit.vue?vue&type=script&lang=ts"
export * from "./SidebarFieldEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f4b2dc')) {
      api.createRecord('45f4b2dc', component.options)
    } else {
      api.reload('45f4b2dc', component.options)
    }
    module.hot.accept("./SidebarFieldEdit.vue?vue&type=template&id=45f4b2dc", function () {
      api.rerender('45f4b2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/SidebarFieldEdit.vue"
export default component.exports